import React from 'react';
import WhiteIsHeMineLogo from "../Assets/white-logo.png"

const WhiteLogo = () => {
  return (
    <img src={WhiteIsHeMineLogo} alt="Logo" className="h-8 cursor-pointer" />
  );
};

export default WhiteLogo;